import React from 'react';
import { customSelect } from "../../misc/customStyle-ReactSelect";
import InputMask from "react-input-mask";
import Select from "react-select";
import { ITypeDynamicInputTypes } from "./types";

function DynamicInput({
	type,
	placeholder,
	name,
	values,
	mask,
	title,
	handleSelectChange = () => {},
	errors,
	options,
	register = () => {},
	onChange = () => {},
	handleCheckValue = () => {},
	value
}: ITypeDynamicInputTypes) {
	switch (type) {
		case "email":
		case "text":
			return (
				<input
					type={type}
					className={`input text-input ${
						errors?.question?.name ? "is-invalid" : ""
					}`}
					placeholder={placeholder}
					{...register(name)}
					onBlur={onChange}
				/>
			);

		case "checklist":
			return (
				<div className='checklist'>
					<div className='checklist-wrapper'>
						{options?.map((option: any) => {
							const show =
								!option.dependent ||
								(option.dependent &&
									values[option.dependent.field] === true);

							const dependent = option.dependent ? true : false;

							if (!show && dependent && values[option.name]) {
								//Removendo valor do dependente se ele não é mais mostrado
								handleCheckValue(option.name, false);
							}

							if (show && dependent) {
								return (
									<div className='dependent-container'>
										{option.title}
										<div className='dependent-options'>
											<label>
												Sim
												<input
													type='radio'
													name={option.name}
													checked={
														values[option.name] ===
														1
															? true
															: false
													}
													onChange={(e) => {
														handleCheckValue(
															option.name,
															1,
														);
													}}
												/>
											</label>
											<label>
												Não
												<input
													type='radio'
													name={option.name}
													checked={
														values[option.name] ===
														2
															? true
															: false
													}
													onChange={(e) => {
														handleCheckValue(
															option.name,
															2,
														);
													}}
												/>
											</label>
										</div>
									</div>
								);
							}

							return (
								show && (
									<label htmlFor={option.name}>
										<input
											type='checkbox'
											className={`input check`}
											name={name}
											value={values[option.name]}
											checked={values[option.name]}
											onChange={(e) => {
												handleCheckValue(
													option.name,
													e.target.value === "true"
														? false
														: true,
												);
											}}
										/>
										{option.title}
									</label>
								)
							);
						})}
					</div>
				</div>
			);

		case "select":
			return (
				<Select
					placeholder={title}
					options={options}
					noOptionsMessage={() => "Essa opção não existe!"}
					onChange={(option) => {
						// @ts-ignore
						handleSelectChange!(name, option!.value);
					}}
					value={value}
					className='input select-input'
					name={name}
					styles={customSelect}
				/>
			);

		case "date":
		case "mask":
		case "number":
			// if (typeof mask === 'object' && mask.type === 'money') {

			// 	// const maskContent =  ;
			// 	// 1 - R$ 0,00 FIXA
			// 	// 2 - R$ 0,99
			// 	// 3 - R$  9,99
			// 	// 4 - R$ 999,9
			// 	// let dynamicMask = mask.prefix + maskContent ;
			// }
			return (
				<InputMask
					mask={mask!}
					className='input text-input'
					placeholder={placeholder}
					type={type === "mask" ? "text" : type}
					{...register(name)}
					onBlur={onChange}
				/>
			);

		default:
			return <div></div>;
	}
}

export default DynamicInput;
